<div class="gpd-full-page contract-review-settings">
  <!-- Save action, top right above the columns -->
  <div class="page-actions">
    <app-gpd-button
      type="default"
      icon="tick"
      text="Save"
      i18n-text="@@save"
      (onClick)="save()"
      [disabled]="!hasChanges || isSaving"
    ></app-gpd-button>
  </div>

  <div class="settings-columns">
    <!-- Left column: analyser prompts -->
    <div class="gpd-config-section">
      <div class="gpd-config-section-header">
        <div>
          <div class="gpd-config-section-title">
            <span i18n="@@analyserPrompts">Analyser Prompts</span>
          </div>
          <div
            class="gpd-config-section-description"
            i18n="@@analyserPromptsDescription"
          >
            Prompts sent to the contract analyser for every review. Leave a
            field blank to use the system default.
          </div>
        </div>
      </div>
      <div class="gpd-config-section-content">
        <div class="setting-field">
          <label i18n="@@extractKeyInfoPrompt">
            Key information extraction prompt
          </label>
          <dx-text-area
            class="gpd-input"
            [(value)]="settings.extractPrompt"
            valueChangeEvent="input"
            [minHeight]="110"
            [maxHeight]="400"
            [autoResizeEnabled]="true"
            [disabled]="isLoading"
          ></dx-text-area>
        </div>

        <div class="setting-field">
          <label i18n="@@executiveSummaryPrompt">
            Executive summary prompt
          </label>
          <dx-text-area
            class="gpd-input"
            [(value)]="settings.createSummaryPrompt"
            valueChangeEvent="input"
            [minHeight]="110"
            [maxHeight]="400"
            [autoResizeEnabled]="true"
            [disabled]="isLoading"
          ></dx-text-area>
        </div>

        <div class="setting-field">
          <label i18n="@@criteriaCheckPrompt">Criteria check prompt</label>
          <dx-text-area
            class="gpd-input"
            [(value)]="settings.checkCriteriaPrompt"
            valueChangeEvent="input"
            [minHeight]="80"
            [maxHeight]="400"
            [autoResizeEnabled]="true"
            [disabled]="isLoading"
          ></dx-text-area>
        </div>
      </div>
    </div>

    <!-- Right column: review criteria -->
    <div class="gpd-config-section">
      <div class="gpd-config-section-header">
        <div>
          <div class="gpd-config-section-title">
            <span i18n="@@reviewCriteria">Review Criteria</span>
          </div>
          <div
            class="gpd-config-section-description"
            i18n="@@reviewCriteriaDescription"
          >
            Criteria each contract is evaluated against during a review.
          </div>
        </div>
        <app-gpd-button
          type="secondary"
          icon="add"
          text="Add"
          i18n-text="@@add"
          (onClick)="addCriterion()"
          [disabled]="isLoading"
        ></app-gpd-button>
      </div>
      <div class="gpd-config-section-content">
        <div
          class="criterion-row"
          *ngFor="
            let criterion of settings.criteria;
            let i = index;
            trackBy: trackByIndex
          "
        >
          <dx-text-area
            class="gpd-input criterion-input"
            [value]="criterion"
            (onValueChanged)="updateCriterion(i, $event.value)"
            valueChangeEvent="input"
            [minHeight]="36"
            [maxHeight]="200"
            [autoResizeEnabled]="true"
            [disabled]="isLoading"
          ></dx-text-area>
          <app-gpd-button
            type="danger-outline"
            icon="delete"
            hint="Remove criterion"
            i18n-hint="@@removeCriterion"
            (onClick)="removeCriterion(i)"
            [disabled]="isLoading"
          ></app-gpd-button>
        </div>

        <div
          class="empty-hint"
          *ngIf="settings.criteria.length === 0"
          i18n="@@noReviewCriteria"
        >
          No criteria defined yet.
        </div>
      </div>
    </div>
  </div>
</div>
